/* eslint-disable react/destructuring-assignment */
import React, { useRef } from 'react';
import { Grid, Button, DialogTitle, Dialog, DialogContent, DialogActions, Stack, TextField } from '@mui/material';
import axios from 'axios';
import { dispatch } from 'store';
import { openSnackbar } from 'store/slices/snackbar';
import { useFormik } from 'formik';

export default function UpdateJoinDateDialog(props) {
    const selectedStudent = props?.data?.row;
    console.log(selectedStudent, 'selectedStudent');

    const formik = useFormik({
        initialValues: {
            joinDate: props.data.joinDate
        },
        onSubmit: (value) => {
            const data = {};
            console.log(props.data.row?.staffMini?.staffId, value.joinDate, 'Data');

            axios
                .put(`/v1/hostel/staff/join-date/mark?staffId=${props.data.row?.staffMini?.staffId}&joinDate=${value.joinDate}`, data, {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                        'Content-Type': 'application/json'
                    }
                })
                .then((result) => {
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: 'Join Date updated successfully',
                            variant: 'alert',
                            alert: {
                                color: 'success'
                            },
                            close: false
                        })
                    );
                    props.handleCloseD();
                    props.fetchStaffDetails(props.fetchData);
                })
                .catch((error) => {
                    console.log(error, 'error');
                });
        }
    });

    return (
        <>
            <Dialog open={props.open} onClose={props.handleCloseD} aria-labelledby="form-dialog-title">
                {props.open && (
                    <>
                        <DialogTitle id="form-dialog-title" minWidth={600}>
                            Update Join Date for <span>{selectedStudent?.staffMini?.staffName}</span>
                        </DialogTitle>
                        <DialogContent>
                            <form onSubmit={formik.handleSubmit}>
                                <Stack spacing={4}>
                                    <Grid item xs={12} md={4} sx={{ mt: 3 }}>
                                        <TextField
                                            type="date"
                                            id="joinDate"
                                            name="joinDate"
                                            value={formik.values.joinDate}
                                            label="Join Date*"
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                            }}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            fullWidth
                                        />
                                    </Grid>
                                </Stack>

                                <Grid item sx={{ display: 'flex', justifyContent: 'end', mt: 3 }}>
                                    <Button variant="contained" onClick={props.handleCloseD} color="error">
                                        Cancel
                                    </Button>
                                    <Button type="submit" variant="contained" sx={{ ml: 4 }}>
                                        Update
                                    </Button>
                                </Grid>
                            </form>
                        </DialogContent>
                        <DialogActions />
                    </>
                )}
            </Dialog>
        </>
    );
}
